import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const { CMS_DATA, CMS_ENV, CMS_COUNTRY, CMS_LOCALE_LANGUAGE, X_CLIENT_HEADER } =
    process.env.REACT_APP_MARKET_VALUES;

export const customerServiceHolidaysApi = createApi({
    reducerPath: 'customerServiceHolidays',
    baseQuery: fetchBaseQuery({
        baseUrl: CMS_DATA,
        prepareHeaders: (headers) => {
            headers.set('x-client-id', X_CLIENT_HEADER);
            return headers;
        },
    }),
    tagTypes: ['Holiday'],
    endpoints: (build) => ({
        getCustomerServiceHolidays: build.query({
            query: () =>
                CMS_LOCALE_LANGUAGE === null || CMS_LOCALE_LANGUAGE === 'null'
                    ? `?contentType=customerServiceHolidayOpeningHours&market=${CMS_COUNTRY}&environment=${CMS_ENV}`
                    : `?contentType=customerServiceHolidayOpeningHours&market=${CMS_COUNTRY}&environment=${CMS_ENV}&locale=${CMS_LOCALE_LANGUAGE}`,
            providesTags: ['Holiday'],
        }),
    }),
});
export const { useGetCustomerServiceHolidaysQuery } = customerServiceHolidaysApi;
